import { IChart } from '@interfaces/kpi/kpiCommon';

export const prepareCorrelateSets = (correlateCharts: Array<IChart>): string[][] =>
	correlateCharts.map(chart => chart.lines[0].points.reduce<Array<string>>((acc, point) => {
		if (point.y !== null) acc.push(point.y);

		return acc;
	}, []));
